export default __webpack_public_path__ + "static/daikin-cd8672148341d278cda5e82fd7e513ca.jpg";